<template>
  <layout>
    <template v-slot:content>
      <v-container class="grey lighten-5">
        <div>
          <h2 class="title">{{$t('moduleTitle')}}</h2>
        </div>
        <!-- Contenido del Dashboard -->
        <v-expansion-panels
          v-model="panel"
          :disabled="disabled"
          multiple
        >
          <!-- Seccion de estadisticas generales -->
          <v-expansion-panel>
            <v-expansion-panel-header>{{$t('sectionTitle')}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Tarjeta de usuario -->
              <v-card
                class="d-inline-block ma-3"
                max-width="300"
                elevation="12"
              >
                <v-card-title 
                  class="title justify-center"
                >{{$t('mainUsers')}}</v-card-title>
                <v-card-text 
                  class="display-3 font-weight-bold text-md-center"
                  :v-model="totalUsers"
                > {{totalUsers}} </v-card-text>
              </v-card>
              <!-- Tarjeta de Apartados -->
              <v-card
                class="d-inline-block ma-3"
                max-width="300"
                elevation="12"
              >
                <v-card-title 
                  class="title justify-center"
                >{{$t('mainReservations')}}</v-card-title>
                <v-card-text 
                  class="display-3 font-weight-bold text-md-center"
                > {{totalReservations}} </v-card-text>
              </v-card>
              <!-- Tarjeta de Parking -->
              <v-card
                class="d-inline-block ma-3"
                max-width="300"
                elevation="12"
              >
                <v-card-title 
                  class="title justify-center"
                >{{$t('mainParking')}}</v-card-title>
                <v-card-text 
                  class="display-3 font-weight-bold text-md-center"
                > {{totalParking.value}}/{{totalParking.maxValue}} </v-card-text>
              </v-card>
              <!-- Tarjeta de LDAP -->
              <v-card
                class="d-inline-block ma-3"
                max-width="310"
                elevation="12"
              >
                <v-card-title 
                  class="title justify-center"
                >{{$t('mainAD')}}</v-card-title>
                <v-card-text 
                  class="display-3 font-weight-bold text-md-center"
                > {{statusLDAP}} </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Seccion de encuestas -->
          <v-expansion-panel>
            <v-expansion-panel-header>{{$t('surveyTittle')}}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- Tabla de contenido -->
              <v-data-table
                :headers="headers"
                :items="surveys"
                :loading="isLoading"
                loading-text="Cargando elementos en tabla"
                color="primary"
              >
                <!-- Panel de acciones -->
                <template v-slot:item.action="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigateSurveyDashboard(item)">
                        <v-icon>mdi-chart-pie</v-icon>
                      </v-btn>
                    </template>
                    <span>{{$t('lblEdit')}}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        
      </v-container>
    </template>
  </layout>
</template>

<script>
  import Layout from "@/components/Layouts/company";
  import i18nMessages from "./i18n.messages";
  import { mapGetters } from "vuex";

  export default {
    i18n: i18nMessages,
    components: {
      layout: Layout
    },
    props: {
      source: String,
    },
    data: () => ({
      panel: [0],
      totalUsers: 0,
      totalReservations: 0,
      totalParking: {
        value: 0,
        maxValue: 0
      },
      statusLDAP: '--',
      //encabezados de la tabla
      headers: [
        { id: "headerName", text: "Tittle", value: "title", sortable: true },
        { id: "headerDesc", text: "Desc", value: "info", sortable: false},
        { id: "headerDate", text: "date", value: "duedate", sortable: true},
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],
      surveys: []
    }),
    created () {
      this.$i18n.locale = this.locale;
      this.loadStatistics();
      this.loadSurveyData();
      this.updateHeadersLocale();
    },

    computed: {
      ...mapGetters(["isLoading"]),
      locale() {
        return this.$store.getters["locale"];
      },
    },

    watch: {
      locale (value) {
        this.$i18n.locale = value;
        this.updateHeadersLocale();
      }
    },

    methods: {
      // Actualiza el idioma de los encabezados de la tabla
      updateHeadersLocale() {
        this.headers = this.headers.map(header => {
          header.text = this.$t(header.id);
          return header;
        });
      },
      loadStatistics(){
        this.$GET('/api/users/statics', [])
        .then(data => {
          // Carga de datos
          this.totalUsers = data.usersInDB;
          this.totalParking = {
            value: data.parking[0].value,
            maxValue: data.parking[0].maxValue
          };
          this.totalReservations = data.reservations.count;
          this.statusLDAP = data.activeDirectory.available ? 'Ok' : 'Check'
        })
        .catch(e => {
          // El usuario no existe
          console.log(e);
          console.log('AttachProfile: El usuario no existe')
        });
      },
      // Obtiene los datoas de encuestas
      loadSurveyData(){
        this.$GETQA('/api/survey/getActive', [])
        .then(data => {
          // Carga de datos
          this.surveys = data;
        })
        .catch(e => {
          // El usuario no existe
          console.log(e);
          console.log('Dashboard: Error al cargar encuestas')
        });
      },
      navigateSurveyDashboard(item) {
        this.$router.push({ path: "/surveyDashboard/" + item.id });
      },
    }
  }
</script>

<style scoped>
.title{
  color: var(--v-primary-base);
}
.logo{
  width: 50%;
  margin: 10px;
}
</style>